const envStatic = {
    reportSectionLPP: "ReportSectionfab14278ad7666508aa0",
    reportSectionIDCard: "ReportSection3dec891e1966b69e9d9e",
    reportSectionIDCardGrafico: "ReportSectioncfd235a7ea0056f572c8",
    reportSectionFunil: "ReportSectionea150e4a351c600992c9",
    reportSectionFunilFabrica: "ReportSection77a6fd80cccd489e99c4",
    reportSectionFeedback: "ReportSection41831c2ff66e1327241e",
    reportSectionLogs: "ReportSection6b8017dd85bda942320d",
    reportSectionTraining: "ReportSection67d8a653ba4fbb0c12e1",
    reportSectionTrainingMonth: "ReportSection00726e1b5aa81ebe36ba",
    reportSectionApprover: "ReportSectiond8bab92595569d157e08",
    reportSectionStandards: "ReportSection8deae2f483eb80215a20",
    reportSectionFactories: "ReportSection4dc9dd468b838e864194",
    reportSectionDTP: "ReportSection9c54329f9db00da2a163",
    reportSectionUX: "ReportSection0418fc2a943843878964",
    reportSectionSupervisor: "ReportSectionec17c55765852bc0dc2c",
    reportSectionPendencias: "ReportSectionf1d26efb1c23d52d17a4",
    reportSectionRelatorioPadroes: "ReportSectionb9082325a8872c442002",
    reportSectionBiTickets: "ReportSection",
    simuladorPessoa: [
        {
            "usuarioMaster": "allancaixeta@hotmail.com"
        },
        {
            "usuarioMaster": "gabrielregooffice@gmail.com"
        },
        {
            "usuarioMaster": "victor.rian@handsonyourdigitaltransformation.com"
        },
        {
            "usuarioMaster": "allan.oliveira@handsonyourdigitaltransformation.com"
        }
    ],
    urlQrCodeReader: "https://nbra-pr-qrcodereader-usea-001-app.azurewebsites.net"
}

export default envStatic;  